import { CheckboxTheme, styles, variants } from '../CheckboxStyles.css';
import { baseTheme } from './CheckboxBaseTheme.css';
import { multiVariantStyles } from './CheckboxVariants.css';

/*******************
 * Component Theme
 *******************/

const CheckboxRedwoodTheme: CheckboxTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { CheckboxRedwoodTheme };
